import React from 'react';

const Items = ({type, title, Page}) => {
    if (Page) {
        return <Page type={type} title={title}/>
    }
};

export default Items;
